import { track, useTracking } from '../../../../lib/analytics'

import HomePageSiteNavSection from './HomePageSiteNavSection'
import LoggedInSiteNavSection from './LoggedInSiteNavSection'
import MinimalSiteNavSection from './MinimalSiteNavSection'

interface SiteNavSectionProps {
  activeNavItem?: string
  showMinimalView: boolean
  user?: {
    currentRegistry: {
      urlSlug: string
    }
  }
  showAcquisitionView: boolean
}

const SiteNavSection = ({
  activeNavItem,
  showMinimalView,
  user,
  showAcquisitionView,
}: SiteNavSectionProps) => {
  const tracker = useTracking()

  const trackClick = (eventCta: string) => {
    tracker.trackEvent({
      event: track.navbarClicked,
      eventCta,
      eventLocation: track.EventLocation.WEB_TOP_NAV,
    })
  }

  if (showAcquisitionView) {
    return <></>
  }

  if (showMinimalView) {
    return <MinimalSiteNavSection trackClick={trackClick} />
  }

  if (user && user.currentRegistry) {
    return (
      <LoggedInSiteNavSection
        activeNavItem={activeNavItem}
        trackClick={trackClick}
        user={user}
      />
    )
  }

  return (
    <HomePageSiteNavSection
      activeNavItem={activeNavItem}
      trackClick={trackClick}
    />
  )
}

export default SiteNavSection
